export const es = {
  // Home Page strings
  title: "Libro de Cielo",
  Home_Description: "Explora los 36 volúmenes del Libro de Cielo escritos por la Sierva de Dios Luisa Piccarreta, donde se revela el don de vivir en la Divina Voluntad.",
  description: "Explora los 36 volúmenes del Libro de Cielo escritos por la Sierva de Dios Luisa Piccarreta, donde se revela el don de vivir en la Divina Voluntad.",
  register: "Registrarse",
  registerMobile: "Registro",
  logout: "Cerrar sesión",
  userLogin: "Iniciar sesión",
  adminAccess: "Acceso de administrador",
  evangelioButton: "Evangelio del Día",
  evangelioButtonDescription: "Lee la lectura del evangelio de hoy",
  temasButton: "Explorar Temas",
  temasDescriptionAuthenticated: "Descubre temas organizados del Libro de Cielo",
  temasDescriptionUnauthenticated: "Inicia sesión para descubrir temas organizados del Libro de Cielo",
  loading: "Cargando volúmenes...",
  errorLoading: "Error loading data",
  sessionExpired: "Sesión expirada. Redirigiendo al login...",
  available: "Disponible",
  unavailable: "No disponible",
  detailedContent: "✨ Contenido detallado",
  requiresAccount: "🔒 Requiere cuenta",
  userNotice: "💡 ¿Sabías que? Al crear una cuenta podrás acceder a contenido detallado de los volúmenes, marcar videos como vistos y tener un seguimiento personalizado de tu progreso.",

  // Search section
  searchTitle: "Buscador de Capítulos",
  searchDescription: "Encuentra y accede directamente a cualquier capítulo específico usando el formato Volumen-Índice",
  searchPlaceholder: "Ejemplo: 11-5",
  searchButton: "Buscar Capítulo",
  searching: "Buscando...",
  searchFormat: "Formato",
  searchFormatExample: "Volumen-Índice",
  searchFormatExampleDetail: "Ejemplo: 11-5 (Volumen 11, Capítulo 5)",
  searchRange: "Rango Disponible",
  searchRangeDetail: "Volúmenes 1-36",
  searchRangeIndexes: "Índices desde 1 en adelante",

  // Search errors
  searchErrorEmpty: "Por favor ingresa un formato válido (ej: 11-5)",
  searchErrorInvalidFormat: "Formato inválido. Usa: Volumen-Indice (ej: 11-5)",
  searchErrorInvalidNumbers: "Ingresa números válidos (ej: 11-5)",
  searchErrorVolumeRange: "El volumen debe estar entre 1 y 36",
  searchErrorIndexPositive: "El índice debe ser un número positivo",
  searchErrorRequiresLogin: "Debes iniciar sesión para acceder al contenido detallado",
  searchErrorVolumeNotFound: "Volumen {volume} no encontrado",
  searchErrorNoContent: "Volumen {volume} no tiene contenido disponible aún",
  searchErrorNavigation: "Error al navegar. Por favor intenta de nuevo.",

  // Donation section
  donationTitle: "Ayúdanos a desarrollar esta plataforma de Libro de Cielo",
  donationDescription: "Tu apoyo nos permite continuar compartiendo las enseñanzas de la Divina Voluntad con el mundo",
  donateButton: "Dona aquí",
  donationUrl: "https://donorbox.org/divinavoluntadapp",

  // Footer
  footerCopyright: "© {year} Fundación Hijos de la Luz, Inc. Todos los derechos reservados.",

  // Gospel Page strings
  gospelTitle: "Evangelio del Día",
  backToHome: "Volver al Inicio",
  loadingGospel: "Cargando evangelio...",
  previousDay: "Día anterior",
  nextDay: "Día siguiente",
  previous: "← Anterior",
  next: "Siguiente →",
  share: "Compartir",
  copyLink: "Copiar Enlace",
  introduction: "Introducción",
  gospel: "Evangelio",
  reflection: "Reflexión del Evangelio del Día",
  relatedLinks: "Enlaces relacionados",
  additionalInfo: "Información adicional",
  liturgicalNote: "Nota litúrgica:",
  source: "Fuente:",
  rights: "Derechos:",
  viewOriginalSource: "Ver fuente original",
  keyboardShortcuts: "Atajos de teclado: ← → para navegar entre días | Esc para volver al inicio",

  // Share messages
  shareSuccess: "✅ Enlace copiado al portapapeles",
  shareError: "❌ Error copiando enlace",
  shareTitle: "Evangelio del día a la Luz de la Divina Voluntad",
  shareWebTitle: "Compartir usando el menú nativo del dispositivo",
  shareClipboardTitle: "Copiar enlace al portapapeles",
  shareFallbackTitle: "Copiar enlace para compartir",
  defaultLinkText: "Enlace",

  // Admin view count
  adminViews: "Visualizaciones (Admin):",
  adminViewsLoading: "Cargando...",
  adminViewsCount: "vistas",

  // Error messages
  gospelNotAvailable: "Lo sentimos, el evangelio para la fecha {date} no está disponible en este momento.",
  gospelLoadError: "No se pudo cargar el Evangelio del Día. Por favor, inténtelo más tarde.",
  tryAgainLater: "Por favor, inténtelo más tarde.",

  // Date formatting
  months: {
    0: "Enero",
    1: "Febrero",
    2: "Marzo",
    3: "Abril",
    4: "Mayo",
    5: "Junio",
    6: "Julio",
    7: "Agosto",
    8: "Septiembre",
    9: "Octubre",
    10: "Noviembre",
    11: "Diciembre"
  },
  weekdays: {
    0: "Domingo",
    1: "Lunes",
    2: "Martes",
    3: "Miércoles",
    4: "Jueves",
    5: "Viernes",
    6: "Sábado"
  },

  // Login Page strings
  backToHome: "Volver al inicio",
  administration: "Administración",
  adminAccess: "Acceso para administradores",
  username: "Usuario",
  password: "Contraseña",
  login: "Iniciar sesión",
  loggingIn: "Iniciando sesión...",
  invalidCredentials: "Usuario o contraseña inválidos",
  adminOnly: "Solo para administradores autorizados",

  // User Login Page strings
  userLogin: "Iniciar Sesión",
  accessYourAccount: "Accede a tu cuenta",
  email: "Email",
  emailOrPasswordIncorrect: "Email o contraseña incorrectos",
  forgotPassword: "¿Olvidaste tu contraseña?",
  noAccount: "¿No tienes una cuenta?",
  createAccount: "Crear cuenta",
  areYouAdmin: "¿Eres administrador?",

  // User Register Page strings
  createAccountTitle: "Crear Cuenta",
  joinBookOfHeaven: "Únete a Libro de Cielo",
  firstName: "Nombre",
  lastName: "Apellido",
  confirmPassword: "Confirmar Contraseña",
  creatingAccount: "Creando cuenta...",
  passwordsDoNotMatch: "Las contraseñas no coinciden",
  passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
  registrationError: "Error al registrar usuario. Verifica que el email no esté en uso.",
  alreadyHaveAccount: "¿Ya tienes una cuenta?",
  registrationSuccessful: "¡Registro Exitoso!",
  verificationEmailSent: "Hemos enviado un enlace de verificación a",
  nextSteps: "Próximos pasos:",
  checkInbox: "1. Revisa tu bandeja de entrada",
  clickVerificationLink: "2. Haz clic en el enlace de verificación",
  loginToAccount: "3. Inicia sesión en tu cuenta",
  accountCreatedSuccessfully: "Tu cuenta ha sido creada exitosamente. Hemos enviado un email de bienvenida a",
  readyToStart: "¡Ya puedes comenzar!",
  accountReadyToUse: "Tu cuenta está lista para usar. Puedes iniciar sesión inmediatamente.",
  goToLogin: "Ir a Iniciar Sesión",
  returnToHome: "Volver al Inicio",

  // Forgot Password Page strings
  backToLogin: "Volver al inicio de sesión",
  forgotPasswordTitle: "¿Olvidaste tu contraseña?",
  forgotPasswordDescription: "Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña",
  forgotPasswordError: "Error al enviar solicitud de recuperación",
  developmentMode: "🔧 Modo desarrollo - Token de prueba:",
  testReset: "Probar restablecimiento",
  emailPlaceholder: "tu-email@ejemplo.com",
  sending: "Enviando...",
  sendRecoveryLink: "Enviar enlace de recuperación",
  rememberedPassword: "¿Recordaste tu contraseña?",

  // Reset Password Page strings
  validatingToken: "Validando token de recuperación...",
  invalidToken: "Token Inválido",
  tokenNotProvided: "Token de recuperación no proporcionado",
  invalidOrExpiredToken: "Token de recuperación inválido o expirado",
  requestNewLink: "Solicitar nuevo enlace",
  resetPasswordTitle: "Restablecer Contraseña",
  enterNewPassword: "Ingresa tu nueva contraseña",
  newPassword: "Nueva Contraseña",
  confirmNewPassword: "Confirmar Nueva Contraseña",
  newPasswordPlaceholder: "Mínimo 6 caracteres",
  confirmNewPasswordPlaceholder: "Confirma tu nueva contraseña",
  passwordRequirements: "Requisitos de la contraseña:",
  atLeast6Characters: "Al menos 6 caracteres",
  passwordsMustMatch: "Las contraseñas deben coincidir",
  resetting: "Restableciendo...",
  resetPassword: "Restablecer contraseña",
  passwordResetSuccess: "¡Contraseña Restablecida!",
  passwordResetSuccessMessage: "Tu contraseña ha sido actualizada exitosamente. Ahora puedes iniciar sesión con tu nueva contraseña.",
  resetPasswordError: "Error al restablecer la contraseña",

  // Email Verification Page strings
  emailVerification: "Verificación de Email",
  verifyingEmail: "Verificando tu email...",
  emailVerified: "¡Email Verificado!",
  verificationError: "Error de Verificación",
  noVerificationToken: "No verification token provided",
  emailVerificationError: "Error verifying email",
  enterEmailToResend: "Enter your email address to resend verification:",
  verificationEmailSent: "Verification email sent! Check your inbox.",
  errorSendingEmail: "Error sending email. Please try again.",
  resendVerificationEmail: "Reenviar Email de Verificación",

  // About Modal strings
  about: "Acerca de",
  closeModal: "Cerrar modal",
  loading: "Cargando...",
  errorLoadingAbout: "Error loading about content",
  retry: "Reintentar",
  fallbackContact: "## 📩 Contacto\n\n¿Tienes preguntas, sugerencias o deseas colaborar con esta misión?\n\nPuedes escribirnos al siguiente correo:\n\n**DivinaVoluntadApp@gmail.com**",

  // News Section strings
  memberContent: "🔒 Contenido para miembros",
  publicAnnouncement: "📢 Anuncio público",

  // About Page strings
  aboutPageTitle: "Acerca de",
  loadingContent: "Cargando contenido...",
  aboutPageFooter: "© 2025 Libro de Cielo - Compartiendo las enseñanzas de la Divina Voluntad",

  // Volume Page strings
  volumePageLoading: "Cargando contenido del volumen...",
  volume: "Volumen",
  verifyingAuth: "Verificando autenticación...",
  videosAvailable: "videos disponibles",
  videosWatched: "vistos",
  videoCountFormat: "{watched} de {total} vistos",
  selectVideoToPlay: "Selecciona un video para reproducir",
  previousButton: "Anterior",
  nextButton: "Siguiente",
  searchChapterTitle: "Buscar Capítulo en este Volumen",
  searchIndexPlaceholder: "Índice (ej: 5)",
  searchButton: "Buscar",
  searchTip: "💡 <strong>Tip:</strong> Solo ingresa el número del capítulo que buscas (ej: 5 para el capítulo 5)",

  // Search errors
  searchErrorIndex: "Por favor ingresa un número de índice (ej: 5)",
  searchErrorPlaylistNotLoaded: "Playlist no cargada. Por favor espera un momento e intenta de nuevo.",
  searchErrorInvalidNumber: "Ingresa un número válido (ej: 5)",
  searchErrorNotAvailable: "No Disponible",
  searchErrorChapterNotFound: "Capítulo {chapter} no disponible en este volumen",
  searchSuccessFound: "✓ Capítulo {chapter} encontrado",

  // Volume errors
  noDetailedContent: "No se encontró contenido detallado para este volumen",
  loginRequired: "Necesitas iniciar sesión para ver este contenido",
  volumeLoadError: "Error cargando el contenido del volumen",
  mainContentError: "Error cargando el contenido principal",
  sessionExpiredRedirect: "Sesión expirada. Redirigiendo al login...",
  noteLoadError: "Error al cargar la nota",

  // Donation message
  helpDevelopMessage: "🙏 Ayúdanos a desarrollar esta página de la plataforma haciendo una donación aquí.",

  // Navigation
  goBack: "Volver",
  inicio: "Inicio",

  // Share functionality
  shareChapter: "Compartir capítulo",
  whatsappInstructions: "Para WhatsApp: Copia el enlace y envía también la imagen de la miniatura",
  linkCopied: "✓ Enlace copiado al portapapeles",
  copyError: "No se pudo copiar automáticamente. Copia manualmente: {url}",

  // Video controls
  markAsWatched: "Marcar como visto",
  markAsUnwatched: "Marcar como no visto",
  watchOnYoutube: "Ver en YouTube",

  // Content sections
  mainContent: "Contenido Principal",
  additionalContent: "Contenido Adicional",
  personalNotes: "Notas Personales",
  saveNote: "Guardar Nota",

  // Temas functionality
  exploreRelatedTopics: "Explorar Temas Relacionados",

  // Volume Page Content Labels (Spanish)
  Volume_Description: "Descripción",
  Volume_Date: "Fecha",
  Volume_Summary: "Resumen",
  Volume_NoteSaved: "Nota guardada",
  Volume_QuestionsAndAnswers: "Preguntas y Respuestas",
  Volume_WritePersonalNotes: "Escribe tus notas personales sobre este capítulo...",
  Volume_Characters: "caracteres",
  Volume_ShowAnswer: "Mostrar respuesta",
  Volume_HideAnswer: "Ocultar respuesta",
  Volume_BiblicalReferences: "Referencias Bíblicas",
  Volume_LookupBiblicalQuote: "Consultar cita bíblica",
  Volume_SpiritualExercises: "Ejercicios Espirituales",
  Volume_KeyPoints: "Puntos Clave",
  Volume_PublicComments: "Comentarios Públicos",
  Volume_PaginationFormat: "{current} de {total}",

  // General UI
  index: "índice",
  chapter: "capítulo",
  description: "descripción",
  saving: "Guardando...",
  
  // Sharing Messages
  Volume_ShareMessage1: "📖 Este capítulo del Libro de Cielo 💫 toca el alma. Regístrate y léelo aquí:",
  Volume_ShareMessage2: "🔥 Este mensaje del Cielo transforma. Entra con tu cuenta y léelo:",
  Volume_ShareMessage3: "✨ Vale la pena. Jesús habla directo al corazón en este capítulo. Solo regístrate:",
  
  // Forgot Password Messages
  forgotPasswordRecoveryMessage: "Si el email existe en nuestro sistema, recibirás un enlace de recuperación"
};